import React, { Component } from 'react';
import throttle from '../Utils/throttle';

const defaultWait = 60;

// decorates a given component with windowWidth and windowHeight props:
// @windowSizeObserver class WebThingie extends Component { ... }
// or (not using es7 decorator syntax):
// export default windowSizeObserver(WebThingie)

const windowSizeObserver = (WrappedComponent) => {
	return class extends Component {
		constructor(props) {
			super(props);

			this.state = {
				width: window.innerWidth,
				height: window.innerHeight
			};

	    }

	    componentDidMount() {
			window.addEventListener('resize', this.updateDimensions);
	    }

		componentWillUnmount() {
			window.removeEventListener('resize', this.updateDimensions);
	    }

	    updateDimensions = throttle(() => {
			this.setState({
				width: window.innerWidth,
				height: window.innerHeight
			});
	    }, defaultWait);

		render() {
			return (
				<WrappedComponent
					windowWidth={this.state.width}
					windowHeight={this.state.height}
					{...this.props}
				/>
			);
		}
	}
};

export default windowSizeObserver;
